import { DateTime } from 'luxon';
import { Flex } from '../../../../GlobalComponents/Flex';
import closeButton from '../../../../assets/imgs/icon/close.svg';
import { RewardDetails } from '../containers/RewardsDashboard';

const isRedeemable = (reward: RewardDetails) => {
	const expirationDate = reward.reward.expire_date
		? DateTime.fromISO(reward.reward.expire_date).toFormat('DDD')
		: DateTime.fromISO(reward.creation_date)
				.plus({ seconds: reward.reward.time_limit })
				.toFormat('DDD');

	let redeemable;
	if (reward.reward.time_limit === null) redeemable = true;
	else if (!reward.reward.expire_date) redeemable = true;

	if (
		DateTime.now().startOf('day') >=
		DateTime.fromISO(expirationDate).startOf('day')
	)
		redeemable = false;

	if (reward.reward.time_limit === null && reward.reward.expire_date === null)
		redeemable = true;
	return { redeemable, expirationDate };
};

const RewardCard = ({
	reward,
	onClick
}: {
	reward: RewardDetails;
	onClick?: () => void;
}): JSX.Element => {
	const { redeemable, expirationDate } = isRedeemable(reward);

	return (
		<Flex
			$flexDirection="column"
			style={{
				borderBottom: '1px solid rgba(87,87,87,0.25)'
			}}
			$height="auto"
			$padding="24px 0"
		>
			<Flex $flexDirection="row" $justifyContent="space-between">
				<h3>{reward.reward.name}</h3>
				{redeemable ? (
					<span
						style={{
							color: '#f47920',
							fontSize: '16px',
							fontWeight: 'bold'
						}}
					>
						Ready to Use
					</span>
				) : (
					<img
						src={closeButton}
						alt="close"
						style={{
							width: '16px',
							height: '16px',
							cursor: 'pointer'
						}}
						onClick={onClick}
					/>
				)}
			</Flex>
			{redeemable === true && (
				<>
					{redeemable && reward.reward.time_limit === null ? null : (
						<>
							<span className="mb-2">
								Expires:{' '}
								<span style={{ fontWeight: 'bold' }}>
									{expirationDate}
								</span>
							</span>
							<span style={{ fontSize: '12px' }}>
								*Redeemable at participating BIGGBY COFFEE
								locations.
							</span>
						</>
					)}
				</>
			)}
			{redeemable === false && <p>This reward is expired</p>}
		</Flex>
	);
};
export default RewardCard;
